import { ROUTE } from "../../routes";
import { api } from "../../configs/api";
import { getAuthHeaders } from "../../configs/config";
import sharedPropsService from "../../SharedPropsService";
export const goBackAction = async (action, _datastore, { navigateWithClear }) => {
    navigateWithClear(ROUTE.CGTC_INIT);
};
export const onChangeAction = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.CGTC_OTP, 'cgtcOtpPage', {
        isError: false
    });
};
export const validateOtp = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    console.warn("**** validateOtp Action Triggered ****", action);
    const otp = action?.payload?.otp;
    const cgtsUserContext = await sharedPropsService.getCgtcUserContext();
    const validateOtpRequestBody = {
        clientRefNo: cgtsUserContext?.otpData?.clientRefNo,
        leadId: cgtsUserContext?.leadId,
        otp: otp,
        otpRef: cgtsUserContext?.otpData?.otpRef,
        reqId: cgtsUserContext?.otpData?.reqId
    };
    const validateOtpResponse = await network.post(`${api.mfcCgsDetailedOTPValidate}`, validateOtpRequestBody, {
        headers: await getAuthHeaders()
    }, async () => { return; }, {
        isPartnerPlatform: true
    });
    if (validateOtpResponse?.status === 200) {
        const jwt = validateOtpResponse?.data?.jwt;
        await sharedPropsService.setToken(jwt);
        setTimeout(async () => {
            await navigateWithClear(ROUTE.CGTC_PROGRESS);
        }, 500);
    }
    else if (validateOtpResponse?.response?.status === 400) {
        if (validateOtpResponse?.response?.data?.voltErrorCode == 'MF_OTP_ATTEMPTS_EXHAUSTED') {
            //
        }
        else {
            console.log("validateOtpResponse: ", validateOtpResponse);
            //duplicated to reset it for the component.
            await setDatastore(ROUTE.CGTC_OTP, 'cgtcOtpPage', {
                isError: false,
                otpErrorMessage: '',
            });
            await setDatastore(ROUTE.CGTC_OTP, 'cgtcOtpPage', {
                isError: true,
                otpErrorMessage: validateOtpResponse?.response?.data?.message
            });
        }
    }
};
